// VHW-147 — components used inside the Fortbildungs-Filter UI lose their DOM
// bindings when CourseFilterLive swaps the `data-swap` regions. They subscribe
// to the `course-search:swapped` event and re-instantiate themselves so the
// freshly-rendered nodes get their listeners back.
export const SWAP_EVENT = 'course-search:swapped'

export const reinitOnSwap = (factory: () => { init: () => void }): void => {
  document.addEventListener(SWAP_EVENT, (): void => {
    factory().init()
  })
}
